import React, { Fragment } from 'react';
import AppHeader from '../../Layout/AppHeader';
import AppSidebar from '../../Layout/AppSidebar';
import AIChatbot from './Pages/Gen_AI/AIChatbot';

const ChatBotWrapper = ({ match }) => (
    <Fragment>
        <AppHeader />
        <div className="app-main">
            <AppSidebar />
            <div className="app-main__outer">
                <div className="app-main__inner">
                    <AIChatbot />
                </div>
            </div>
        </div>
    </Fragment>
);

export default ChatBotWrapper;